import React, { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import styles from "../Settings.module.scss";
import WorkTypeList from "./WorkTypeList";
import EditCategory from "./EditWorkType";
import { toast } from "react-toastify";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { useActiveDepartments } from "services/departmentService";
import { addWorkTypes } from "services/workTypeService";

const WorkType = (props) => {
  const [addnewform, setaddnewform] = useState(false);
  const [departmentID, setDepartmentID] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { data: departments, loading: departmentsLoading } =
    useActiveDepartments();
  const formattedDepartments = React.useMemo(() => {
    if (!departments) return [{ name: "ALL", departmentID: 0 }];
    return [{ name: "ALL", departmentID: 0 }, ...departments];
  }, [departments]);

  const closeform = () => {
    setaddnewform(false);
  };

  React.useEffect(() => {
    if (props.onClose === false) {
      closeform();
    }
  }, [props.onClose]);

  const onChange = (e) => {
    setDepartmentID(e?.value?.departmentID || 0);
  };

  const handleSubmit = async (e) => {
    setIsSubmitting(true);
    try {
      await addWorkTypes({
        ...e,
        departmentId: e.departmentId?.departmentID,
        appCode: e.appCode?.appCode,
        defaultProfitCost: e.defaultProfitCost?.nominalRef,
        rateCategoryId: e.rateCategoryId?.rateCategoryId,
        active: true,
      });
      toast.success("Work Type Added");
    } catch (error) {
      toast.error("Error Occurred");
    } finally {
      setIsSubmitting(false);
      setaddnewform(false);
    }
  };

  return (
    <React.Fragment>
      <>
        <div className="container my-5 mx-auto col-xxl-9 col-xl-10 col-lg-11 col-12   ">
          <div className="row mb-3 ">
            <div className="col-lg-2 col-md-3 ms-auto">
              <Button
                className={`common-btn ${styles[`button`]}`}
                onClick={() => {
                  setaddnewform(true);
                  props.open();
                }}
              >
                Add <br />
                Work Type
              </Button>
            </div>

            <div className="form-group d-flex flex-column">
              <Label>Department</Label>
              <ComboBox
                data={formattedDepartments}
                className={`${styles["work-type-field-style"]} mt-1 mb-2`}
                iconClassName="wa"
                required={true}
                textField={"name"}
                placeholder={"Search Department"}
                onChange={onChange}
                value={
                  formattedDepartments.find(
                    (d) => d.departmentID === departmentID
                  ) || { name: "ALL", departmentID: 0 }
                }
                disabled={departmentsLoading}
              />
            </div>
          </div>
          <div className="row">
            <div className="w-100 ">
              <WorkTypeList departmentID={departmentID} />
            </div>
          </div>
        </div>
      </>

      {addnewform && (
        <EditCategory
          cancelEdit={closeform}
          onSubmit={handleSubmit}
          type="addNew"
          isSubmitting={isSubmitting}
        />
      )}
    </React.Fragment>
  );
};

export default WorkType;
